import { getSupabaseClient } from './supabase';
import type {
  TermsContentItem,
  TermsAudience,
  CreateTermsContentItem,
  UpdateTermsContentItem
} from '@types';

export async function fetchTermsContent(audience: TermsAudience): Promise<TermsContentItem[]> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('terms_content')
    .select('*')
    .eq('audience', audience)
    .order('sort_order', { ascending: true });

  if (error) {
    console.error('Error fetching terms content:', error);
    throw error;
  }

  return data || [];
}

export async function createTermsContentItem(item: CreateTermsContentItem): Promise<TermsContentItem> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('terms_content')
    .insert(item)
    .select()
    .single();

  if (error) {
    console.error('Error creating terms content item:', error);
    throw error;
  }

  return data;
}

export async function updateTermsContentItem(
  id: string,
  updates: UpdateTermsContentItem
): Promise<TermsContentItem> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('terms_content')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    console.error('Error updating terms content item:', error);
    throw error;
  }

  return data;
}

export async function deleteTermsContentItem(id: string): Promise<void> {
  const supabase = getSupabaseClient();

  const { error } = await supabase
    .from('terms_content')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting terms content item:', error);
    throw error;
  }
}

export async function reorderTermsContent(
  audience: TermsAudience,
  items: Array<{ id: string; sort_order: number }>
): Promise<void> {
  const supabase = getSupabaseClient();

  // Update all items' sort_order in a transaction-like manner
  const updates = items.map(item =>
    supabase
      .from('terms_content')
      .update({ sort_order: item.sort_order })
      .eq('id', item.id)
      .eq('audience', audience)
  );

  await Promise.all(updates);
}
